import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/slack-notification-channel/constants';
import { slackNotificationChannelQueryKeys } from '@/modules/slack-notification-channel/queries/queryKeys';
import type { SlackNotificationChannelApi } from '@/modules/slack-notification-channel/types';

/**
 * The tenant's configured Slack notification channel, or `null` when none is set
 * (hiring-manager notifications are then delivered as direct messages).
 */
export const useSlackNotificationChannelQuery = (
  options?: Omit<
    UseQueryOptions<SlackNotificationChannelApi | null, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: slackNotificationChannelQueryKeys.current(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.notificationChannel);
      return data ?? null;
    },
    ...options,
  });
};
